
import { useToast as useToastHook, toast } from "@/hooks/use-toast";

// Create a wrapper function that returns both the state and the toast functions
export const useToast = () => {
  const state = useToastHook();
  return {
    ...state,
    toast,
  };
};

// Re-export the toast function
export { toast };
